<template>
  <modal-base
    class="cordel-modal-confirmation"
    :title="title"
    @close="close"
  >
    <template slot="subheader">
      <slot>
        Você tem certeza?
      </slot>
    </template>

    <form-button-group
      align="right"
      class="cordel-modal-confirmation-buttons"
    >
      <form-button
        :disabled="loading"

        aria-label="Cancelar"

        color="secondary"
        @click="close"
      >
        Cancelar
      </form-button>

      <form-button
        :color="color"
        :loading="loading"

        aria-label="Confirmar"

        @click="confirm"
      >
        Confirmar
      </form-button>
    </form-button-group>
  </modal-base>
</template>

<script>
  import FormButton from '@cordel/components/Form/Button.vue';
  import FormButtonGroup from '@cordel/components/Form/Button/Group.vue';

  import ModalBase from '@cordel/components/Modal/Base.vue';

  export default {
    name: 'CordelModalConfirmation',
    components: {
      FormButton,
      FormButtonGroup,
      ModalBase,
    },
    props: {
      color: {
        type: String,
        default: undefined,
      },
      title: {
        type: String,
        default: 'Confirmar',
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      close() {
        if (this.loading) {
          return;
        }

        this.$emit('close');
      },
      confirm() {
        if (this.loading) {
          return;
        }

        this.$emit('confirm');
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-modal-confirmation {
  }

  .cordel-modal-confirmation-buttons {
    border-top: var(--cordel-border-width-thin) solid var(--cordel-color-constant-dark);
    margin-top: var(--cordel-spacing-giga);
    padding-top: var(--cordel-spacing-xl);
  }
</style>
